import { Hourglass, SignOut } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="pending-approval">
      <header className="border-b border-black/10 px-6 py-4"><Logo size="sm"/></header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl text-center">
          <div className="w-16 h-16 mx-auto bg-[#D90429]/10 border border-[#D90429]/30 flex items-center justify-center">
            <Hourglass size={28} weight="bold" className="text-[#D90429]" />
          </div>
          <div className="overline mt-6">Access pending</div>
          <h1 className="font-display text-5xl font-black tracking-tighter mt-3">Hi {user?.name?.split(" ")[0] || "there"} — your access is awaiting approval.</h1>
          <p className="text-[#4A4D57] mt-5 leading-relaxed">
            Reyansh is access-controlled. Your administrator needs to assign you a role before you can use the workspace.
            Please contact <span className="font-mono-shelv text-[#D90429]">mukesh.panchal@shelvestech.com</span> to request access.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 bg-[#F5F6F8] border border-black/10 px-4 py-3 text-sm">
            <span className="text-[#717680]">Signed in as</span>
            <span className="font-mono-shelv text-[#0A0A0A]">{user?.email}</span>
          </div>
          <div className="mt-8">
            <button onClick={logout} data-testid="pending-logout-button" className="inline-flex items-center gap-2 px-5 py-3 border border-black/15 text-sm font-semibold hover:bg-[#0A0A0A] hover:text-white transition">
              <SignOut size={16} weight="bold"/> Sign out
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
